import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import './styles.css';
import './App.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { sendToVercelAnalytics } from './vitals';

// Add console log for debugging
console.log("Starting React application");

// Get the root element
const rootElement = document.getElementById('root');
console.log("Root element:", rootElement);

// Create a root
const root = createRoot(rootElement);
console.log("Created React root");

// Render your application
root.render(<App />);
console.log("Rendered App component");

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
reportWebVitals(sendToVercelAnalytics);
